export const CARD_FIELDS = {
  CARD_NAME: 'cardName',
  CARD_NUMBER: 'cardNumber',
  CARD_EXPIRATION_DATE: 'cardExpirationDate',
  CARD_CVC: 'cardCvc'
};
